import IBaseComponent from '@components/FormFlow/Interfaces/Base/IBaseComponent';
import ICalculatorComponent from '@components/FormFlow/Interfaces/FormflowComponents/ICalculatorComponent';
import IConfirmComponent from '@components/FormFlow/Interfaces/FormflowComponents/IConfirmComponent';
import IModelComponent from '@components/FormFlow/Interfaces/FormflowComponents/IModelComponent';
import INumberComponent from '@components/FormFlow/Interfaces/FormflowComponents/INumberComponent';
import IQRCodeComponent from '@components/FormFlow/Interfaces/FormflowComponents/IQRCodeComponent';
import IImageRecognitionComponent from '@components/FormFlow/Interfaces/FormflowComponents/IImageRecognitionComponent';
import ISampleComponent from '@components/FormFlow/Interfaces/FormflowComponents/ISampleComponent';
import IScoreComponent from '@components/FormFlow/Interfaces/FormflowComponents/IScoreComponent';
import { ComponentType } from '@interfaces/component-type';
import Switch from '@material-ui/core/Switch';
import I18n from '@src/i18n';
import { Theme } from '@src/styled-components';
import { Col, InputNumber, Row } from 'antd';
import React from 'react';
import styled from 'styled-components';

import ModelComponentProcess from './components/3DModelComponentProcess';
import CalculatorComponentProcess from './components/CalculatorComponentProcess';
import ConfirmComponentProcess from './components/ConfirmComponentProcess';
import NumberComponentProcess from './components/NumberComponentProcess';
import QRCodeComponentProcess from './components/QRCodeComponentProcess';
import ImageRecognitionComponentProcess from './components/ImageRecognitionComponentProcess';
import SampleSettingsComponent from './components/SampleSettingsComponent';
import ScoreComponentProcess from './components/ScoreComponentProcess';



export interface IConfigProcessComponentProps {
  onChangeDescription: Function;
  onChangeRequired: Function;
  onChangeMin: Function;
  onChangeMax: Function;
  onChangeRepeat: Function;
  onChangeSelectAPI?: Function;
  onChangeHourInsertion: Function;
  setCurrentPage: Function;
  currentComponent: any;
}


interface IConfigProcessComponentState {
  checked: boolean
}


export default class ConfigProcessComponent extends React.Component<IConfigProcessComponentProps, IConfigProcessComponentState> {

  constructor(props: IConfigProcessComponentProps) {
    super(props);
    this.state = {
      checked: false
    }
  }

  handleChange(checked: any) {
    this.setState({ checked });
  }
  componentDidMount(){
    if(this.props.currentComponent.type === ComponentType.CALCULATOR)
    this.props.setCurrentPage()
  }
  

  renderDefaultConfigs(component: any) {
    if (component !== null) {
      if (
        component.type !== ComponentType.CALCULATOR &&
        component.type !== ComponentType.SAMPLETEXT &&
        component.type !== ComponentType.SAMPLEIMAGE &&
        component.type !== ComponentType.SAMPLEVIDEO &&
        component.type !== ComponentType.SCORE &&
        component.type !== ComponentType.MODEL && 
        component.type !== ComponentType.QRCODE

      ) {
        return (
          <>
            <CardConfig >
              <Row>
                <Col sm={20} md={20} xl={20} >
                  {I18n.l('label.requiredComponent')}
                </Col>
                <Col sm={4} md={4} xl={4} >
                  <Switch
                    color="primary"
                    onChange={this.props.onChangeRequired}
                    checked={this.props.currentComponent.required}
                  />
                </Col>
              </Row>
            </CardConfig>
            {(this.props.currentComponent.required && component.type === ComponentType.GOTO) &&
              <CardConfig  >
                {I18n.l('process.component.MinMultiple')}
                <div>
                  <InputNumber
                    onChange={this.props.onChangeMin()}
                    defaultValue={this.props.currentComponent.minMultiple}
                    style={{ marginTop: '10px', width: '40%' }}
                    min={1}
                    placeholder={I18n.l('label.insertNumberPlaceholder')}
                  />
                </div>
              </CardConfig>
            }
          </>
        );
      }
      else return;
    }
    else return
  }

  renderExtrasConfigs(component: any) {
    if (component !== null) {
      if (
        component.type === ComponentType.TEXT ||
        component.type === ComponentType.PHOTO ||
        component.type === ComponentType.NUMBER ||
        component.type === ComponentType.DATE ||
        component.type === ComponentType.AUDIO ||
        component.type === ComponentType.GOTO ||
        component.type === ComponentType.DRAW || 
        component.type === ComponentType.FILEUPLOAD
      ) {
        return (
          <>
          <CardConfig >
            <Row>
              <Col sm={20} md={20} xl={20} >
                {component.type === ComponentType.GOTO &&
                  I18n.l('label.components.repeatPages')
                }
                {component.type !== ComponentType.GOTO &&
                  I18n.l('label.repeatComponent')
                }
              </Col>
              <Col sm={4} md={4} xl={4} >
                <Switch
                  color="primary"
                  onChange={this.props.onChangeRepeat}
                  checked={component.repeat}
                />
              </Col>
            </Row>
            {component.type === ComponentType.GOTO &&
              <p style={{ color: '#7F7F7F', width: '75%' }}>{I18n.l('label.components.todo.single')}</p>
            }
          </CardConfig>
          {component.type === ComponentType.DATE &&
          <CardConfig>
            <Row>
              <Col sm={20} md={20} xl={20}>
                {I18n.l('allow.hour.insertion')}
              </Col>
              <Col sm={4} md={4} xl={4} >
              <Switch
                color="primary"
                onChange={this.props.onChangeHourInsertion}
                checked={component.hour}
              />
              </Col>
            </Row>
          </CardConfig>}
          </>
        )
      }
      if (component.type === ComponentType.SELECT) {
        return (
          <>
            <CardConfig >
              <Row>
                <Col sm={20} md={20} xl={20} >
                  {I18n.l('label.repeatComponent')}
                </Col>
                <Col sm={4} md={4} xl={4} >
                  <Switch
                    color="primary"
                    onChange={this.props.onChangeRepeat}
                    checked={component.multiple}
                  />
                </Col>
              </Row>
              {component.multiple === true &&
                <Row style={{ padding: '3px 0'}}>
                  <Col sm={16} md={16} xl={16} >
                    {I18n.l('Min')}
                  </Col>
                  <Col sm={8} md={8} xl={8} >
                    <InputNumber
                      onChange={this.props.onChangeMin()}
                      defaultValue={this.props.currentComponent.minMultiple}
                      style={{width: '100%' }}
                      placeholder={I18n.l('label.insertNumberPlaceholder')}
                    />
                  </Col>
                </Row>}
              {component.multiple === true &&
                <Row style={{ padding: '3px 0'}}>
                  <Col sm={16} md={16} xl={16} >
                    {I18n.l('Max')}
                  </Col>
                  <Col sm={8} md={8} xl={8} >
                    <InputNumber
                      onChange={this.props.onChangeMax()}
                      defaultValue={this.props.currentComponent.maxMultiple}
                      style={{width: '100%' }}
                      placeholder={I18n.l('label.insertNumberPlaceholder')}
                    />
                  </Col>
                </Row>}
            </CardConfig>
          </>
        )

      }  
      if (component.type === ComponentType.MODEL || component.type === ComponentType.IMAGERECOGNITION) {
        return (
          <div>
            <a style={{ color: 'transparent' }} href="mailto: goepik@goepik.com.br">
              <BoxAlert  >
                <h3 style={{ color: 'white', fontWeight: 'bold', textAlign: 'center' }}> {I18n.l('label.component.contactUs').toUpperCase()}</h3>
                <p style={{ color: 'white', marginTop: '2rem', textAlign: 'center' }}>{I18n.l('form.labels.email')}:
                  <u style={{ paddingLeft: '5px', fontWeight: 'normal', color: 'white', }}>goepik@goepik.com.br</u>
                </p>
              </BoxAlert>
            </a>
          </div>
        )
      }
      else {
        return;
      }
    }
    else {
      return;
    }
  }

  renderComponent = (component: IBaseComponent | null) => {
    if (component !== null) {
      switch (component.type) {
        case ComponentType.CONFIRM: {
          return (<ConfirmComponentProcess {...component as IConfirmComponent} />)
        }
        case ComponentType.NUMBER: {
          return (<NumberComponentProcess {...component as INumberComponent} />)
        }
        case ComponentType.CALCULATOR: {
          return (<CalculatorComponentProcess {...component as ICalculatorComponent} />)
        }
        case ComponentType.MODEL: {
          return (<ModelComponentProcess {...component as IModelComponent} />)
        }
        case ComponentType.SCORE: {
          return (<ScoreComponentProcess {...component as IScoreComponent} />)
        }
        case ComponentType.SAMPLE: {
          return (<SampleSettingsComponent {...component as ISampleComponent} />)
        }
        case ComponentType.QRCODE: {
          return (<QRCodeComponentProcess {...component as IQRCodeComponent} />)
        }
        case ComponentType.IMAGERECOGNITION: {
          return (<ImageRecognitionComponentProcess {...component as IImageRecognitionComponent} />)
        }
        default: {
          return;
        }
      }
    }
    else {
      return;
    }
  }

  render() {
    const {
      currentComponent
    } = this.props;
    return (
      <>
        {this.renderDefaultConfigs(currentComponent)}
        {this.renderExtrasConfigs(currentComponent)}
        <CardComponent>
          {this.renderComponent(currentComponent)}
        </CardComponent>
      </>
    );
  }
}

//#region CSS
const CardConfig = styled.div`
padding: 25px 25px 25px 25px;
height:auto;
border-bottom: 1px solid  ${Theme.secondary.lightGrey};
background-color: #F6FCFD;

/* .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track {
    opacity: 1;
    background-color: #1590ff;
} */
`;

const CardComponent = styled.div`
   padding: 25px 25px 25px 25px;
   height:auto;
   background-color: #F6FCFD;
   `;

const BoxAlert = styled.div`
    background-color: ${Theme.secondary.red};
    border-radius: 5px;
    font-weight: bold;
    color: ${Theme.secondary.midGrey};
    padding: 20px 30px 10px 30px;
    margin: 20px;
`;
